export default "__VITE_ASSET__BWTlD$Lw__"